/* This example requires Tailwind CSS v2.0+ */
import { memo } from "react";
import {} from "@headlessui/react";
import classnames from "classnames";

interface IProps {
  enabled: boolean;
  setEnabled: (flag: boolean) => void;
  label: React.ReactNode | string;
  disabled?: boolean;
  className?: string;
  buttonClassName?: string;
  labelClassName?: string;
}

function ToggleButton({
  enabled,
  setEnabled,
  label,
  className,
  disabled = false,
  buttonClassName,
  labelClassName,
  ...rest
}: IProps) {
  const handleToggle = () => {
    if (disabled) {
      return;
    }
    setEnabled(!enabled);
  };

  return (
    <div
      className={classnames(
        "flex flex-row items-center justify-center",
        className
      )}
    >
      <button
        type="button"
        onClick={handleToggle}
        aria-pressed={enabled}
        className={classnames(
          "inline-flex h-10 items-center justify-center rounded-full border px-4 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-offset-2",
          {
            "bg-slate-900 text-white border-slate-900 shadow-sm focus:ring-slate-900": enabled,
            "bg-white text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50 focus:ring-slate-300": !enabled,
          },
          disabled && "cursor-not-allowed opacity-60 hover:bg-white hover:border-slate-200",
          buttonClassName
        )}
        disabled={disabled}
        {...rest}
      >
        <span
          className={classnames(
            "text-sm font-semibold",
            enabled ? "text-white" : "text-slate-700",
            labelClassName
          )}
        >
          {label}
        </span>
      </button>
    </div>
  );
}

export default memo(ToggleButton);
